import React, { Component } from "react";
import debounce from "lodash.debounce";
import LayoutContext, { ILayoutContext } from "./LayoutContext";
import { ILayoutSettings, getLayoutSettings, getSiteImageDimensions } from "../../models/layout";

export type LayoutProviderProps = {
	onResize?: (settings: ILayoutSettings) => any;
};

type LayoutProviderState = {
	settings: ILayoutSettings;
	refresh: number;
};

class LayoutProvider extends Component<LayoutProviderProps, LayoutProviderState> {
	// subscribe to resize to update layout settings and unsucscribe
	private _onResize = debounce(this.onAppResize.bind(this), 150, { trailing: true });
	private _isMounted: boolean = false;
	private readonly DEFAULT_SETTINGS: ILayoutSettings = getLayoutSettings();

	state = {
		settings: this.DEFAULT_SETTINGS,
		refresh: 0,
	};

	componentDidMount() {
		this._isMounted = true;
		window.addEventListener("resize", this._onResize);
	}

	componentWillUnmount() {
		this._isMounted = false;
		window.removeEventListener("resize", this._onResize);
	}

	onAppResize() {
		if (!this._isMounted) return;
		const settings: ILayoutSettings = getLayoutSettings();
		const hasChange: boolean =
			settings.isDesktopRes !== this.state.settings.isDesktopRes ||
			settings.isMobileOrTabletRes !== this.state.settings.isMobileOrTabletRes ||
			settings.isMobileRes !== this.state.settings.isMobileRes ||
			settings.isScreenWidthSm !== this.state.settings.isScreenWidthSm ||
			settings.orientation !== this.state.settings.orientation ||
			settings.isMobileOrTabletDevice !== this.state.settings.isMobileOrTabletDevice;
		console.log("onAppResize() hasChange:", hasChange);
		if (hasChange) {
			this.setState({ settings, refresh: hasChange ? this.state.refresh + 1 : this.state.refresh });
			if (this.props.onResize) {
				this.props.onResize(settings);
			}
		}
	}

	render() {
		// $grid-breakpoints: (
		// 	xs: 0,
		// 	sm: 576px,
		// 	md: 769px,
		// 	lg: 992px,
		// 	xl: 1200px,
		// ) !default;

		// 380 X 359 desktop site

		// let siteImageWidth: number;
		// let siteImageHeight: number;
		// // let imageWidth100Pct: boolean = false;

		// if (this.state.settings.isDesktopRes) {
		// 	siteImageWidth = 380;
		// 	siteImageHeight = 389;
		// 	// imageWidth100Pct = false;
		// } else {
		// 	// sheri todo
		// 	// imageWidth100Pct = true;
		// 	siteImageWidth = window.innerWidth - 30;
		// 	siteImageHeight = Math.round((window.innerWidth / 380 - 30) * 389);
		// }

		// const siteImageWidth = this.state.settings.isDesktopRes ? 380 : "100%"; //485; //this.state.settings.isDesktopRes ? 400 - 50 : "100%";
		// const siteImageHeight = this.state.settings.isDesktopRes ? 359 : undefined;

		return (
			<LayoutContext.Provider
				value={{
					settings: this.state.settings,
					...(getSiteImageDimensions(this.state.settings) as ILayoutContext),
					// imageWidth: siteImageWidth,
					// imageHeight: siteImageHeight,
					// imageWidth100Pct: imageWidth100Pct,
					// imageHeight100Pct: false,
					onResize: this.props.onResize,
				}}
			>
				{this.props.children}
			</LayoutContext.Provider>
		);
	}
}

export default LayoutProvider;
